module.exports = __webpack_public_path__ + "0c4d0982a295e05427e91bd2842ddfe3.jpg";


//////////////////
// WEBPACK FOOTER
// ./pages/media/2/no_image.jpg
// module id = 576
// module chunks = 0